export default __webpack_public_path__ + "static/media/afp-capital.72877d9d.svg";